import React from 'react';

import {
  useTranslation,
} from 'react-i18next';


export const SIGNUP_PERMISSION_GROUPS = [
  {
    key:
      'hiCps',

    titleKey:
      'signup.permissions.groups.hiCps',

    permissions: [
      {
        code:
          'C1',

        labelKey:
          'signup.permissions.items.c1',

        enabled:
          true,
      },
      {
        code:
          'C2',

        labelKey:
          'signup.permissions.items.c2',

        enabled:
          true,
      },
      {
        code:
          'C3',

        labelKey:
          'signup.permissions.items.c3',

        enabled:
          true,
      },
      {
        code:
          'C4',

        labelKey:
          'signup.permissions.items.c4',

        enabled:
          true,
      },
    ],
  },

  {
    key:
      'pgSolution',

    titleKey:
      'signup.permissions.groups.pgSolution',

    permissions: [
      {
        code:
          'PE',

        labelKey:
          'signup.permissions.items.pe',

        enabled:
          true,
      },
      {
        code:
          'PM',

        labelKey:
          'signup.permissions.items.pm',

        enabled:
          true,
      },
      {
        code:
          'PS',

        labelKey:
          'signup.permissions.items.ps',

        enabled:
          true,
      },
      {
        code:
          'PC',

        labelKey:
          'signup.permissions.items.pc',

        enabled:
          false,
      },
    ],
  },
];


export function getDefaultSignupAuth() {
  return SIGNUP_PERMISSION_GROUPS
    .flatMap(
      (
        group,
      ) =>
        group.permissions,
    )
    .filter(
      (
        permission,
      ) =>
        permission.enabled,
    )
    .map(
      (
        permission,
      ) =>
        permission.code,
    )
    .join('|');
}


export default function SystemPermissionPreview() {
  const {
    t,
  } = useTranslation(
    'app',
  );


  return (
    <div
      className="signup-permission-section"
    >
      <div
        className="signup-permission-header"
      >
        <h3>
          {t(
            'signup.permissions.title',
          )}
        </h3>

        <p>
          {t(
            'signup.permissions.description',
          )}
        </p>
      </div>


      <div
        className="signup-permission-groups"
      >
        {SIGNUP_PERMISSION_GROUPS.map(
          (
            group,
          ) => (
            <div
              key={
                group.key
              }
              className="signup-permission-group"
            >
              <label
                className="signup-permission-group-title"
              >
                <input
                  type="checkbox"
                  checked
                  readOnly
                  tabIndex={
                    -1
                  }
                />

                <span>
                  {t(
                    group.titleKey,
                  )}
                </span>
              </label>


              <div
                className="signup-permission-items"
              >
                {group.permissions.map(
                  (
                    permission,
                  ) => (
                    <label
                      key={
                        permission.code
                      }
                      className={
                        permission.enabled
                          ? 'signup-permission-item is-readonly'
                          : 'signup-permission-item is-disabled'
                      }
                    >
                      <input
                        type="checkbox"
                        checked={
                          permission.enabled
                        }
                        disabled={
                          !permission.enabled
                        }
                        readOnly
                        tabIndex={
                          -1
                        }
                      />

                      <span>
                        {t(
                          permission.labelKey,
                        )}
                      </span>
                    </label>
                  ),
                )}
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}